import React, { Component, useContext, useState } from "react";
import { isEmpty } from "lodash";
import moment from "moment";
import { Pagination } from "antd";

import { ExpenseReportsContext } from "./../ExpenseReportsContext";

import { summaryApprovalItems, expenseReportsDetails } from "./ExpenseReportsWeekly.utils.js";

const CardContent = ({ item, index, indexWeeklyCardOpen, setIndexWeeklyCardOpen }) => {
  const getTransformExpandBtn = () => (index === indexWeeklyCardOpen ? "rotate(-90)" : "rotate(90)");
  const { handleOnClickDetailsView } = useContext(ExpenseReportsContext);

  return (
    <div className="flex divide-x divide-gray-200">
      <div className="w-2/12 flex flex-col items-center justify-center mx-4>">
        <div className="font-bold mb-4">{item.fullName}</div>
        <div className="text-lg">{item.weekLabel}</div>
      </div>
      <div className="w-8/12 grid gap-2 grid-cols-3 mx-2 pl-6">
        {item.summary.map((summaryItem, index) => (
          <div className="flex items-center mb-2">
            <div
              className={`${summaryItem.style} mr-3 rounded-full h-8 w-8 flex summaryItems-center justify-center cursor-default`}
            >
              <img
                className="p-header-menu-logo"
                src={summaryItem.icon}
                style={{
                  maxHeight:
                    summaryItem.icon === "/img/check.png" || summaryItem.icon === "/img/timer.png" ? "70%" : "100%",
                  paddingTop:
                    summaryItem.icon === "/img/check.png" || summaryItem.icon === "/img/timer.png" ? "5px" : "0"
                }}
              />
            </div>
            <div className={`${summaryItem.textColor} font-bold cursor-default `}>
              {summaryItem.count} {summaryItem.label}
            </div>
          </div>
        ))}
      </div>
      <div className="cursor-pointer pl-8 flex items-center justify-center mx-4>">
        <div
          onClick={() =>
            handleOnClickDetailsView({
              match: {
                email: item.email
              },
              start_date: moment(item.start_date).format("YYYY-MM-DD")
            })
          }
          className="bg-orange-500 mr-5 rounded-full h-16 w-16 flex items-center justify-center"
        >
          <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 84.064 91.561">
            <g id="planning-orange" transform="translate(-203.035 -754.845)">
              <g stroke="white" id="Groupe_357" data-name="Groupe 357" transform="translate(-1 -1)">
                <path
                  id="calendar"
                  d="M13.3,95.694v-65.4a6.567,6.567,0,0,1,1.911-4.629,6,6,0,0,1,4.556-1.911h6.467V18.83a8.1,8.1,0,0,1,2.351-5.805A7.72,7.72,0,0,1,34.316,10.6H37.55a8.155,8.155,0,0,1,8.083,8.23v4.923h19.4V18.83a8.1,8.1,0,0,1,2.351-5.805A7.72,7.72,0,0,1,73.116,10.6h3.233a8.155,8.155,0,0,1,8.083,8.23v4.923H90.9a6.524,6.524,0,0,1,6.467,6.54V95.621a6.567,6.567,0,0,1-1.911,4.629,6,6,0,0,1-4.556,1.911H19.767A6.524,6.524,0,0,1,13.3,95.694Zm6.467,0H90.9V43.374H19.767ZM32.7,33.6a1.669,1.669,0,0,0,.441,1.176,1.551,1.551,0,0,0,1.176.441H37.55a1.669,1.669,0,0,0,1.176-.441,1.551,1.551,0,0,0,.441-1.176V18.9a1.669,1.669,0,0,0-.441-1.176,1.551,1.551,0,0,0-1.176-.441H34.316A1.517,1.517,0,0,0,32.7,18.9Zm38.8,0a1.669,1.669,0,0,0,.441,1.176,1.551,1.551,0,0,0,1.176.441h3.233a1.669,1.669,0,0,0,1.176-.441,1.551,1.551,0,0,0,.441-1.176V18.9a1.669,1.669,0,0,0-.441-1.176,1.551,1.551,0,0,0-1.176-.441H73.116A1.517,1.517,0,0,0,71.5,18.9Z"
                  transform="translate(190.734 745.245)"
                  fill="#ffffff"
                />
                <rect
                  id="Rectangle_231"
                  data-name="Rectangle 231"
                  width="7.974"
                  height="7.974"
                  transform="translate(218.389 797.561)"
                  fill="#ff5200"
                />
                <rect
                  id="Rectangle_238"
                  data-name="Rectangle 238"
                  width="7.974"
                  height="7.974"
                  transform="translate(218.389 811.664)"
                  fill="#ff5200"
                />
                <rect
                  id="Rectangle_242"
                  data-name="Rectangle 242"
                  width="7.974"
                  height="7.974"
                  transform="translate(218.389 826.268)"
                  fill="#ff5200"
                />
                <rect
                  id="Rectangle_233"
                  data-name="Rectangle 233"
                  width="7.974"
                  height="7.974"
                  transform="translate(250.285 797.561)"
                  fill="#ff5200"
                />
                <rect
                  id="Rectangle_235"
                  data-name="Rectangle 235"
                  width="7.974"
                  height="7.974"
                  transform="translate(250.285 811.664)"
                  fill="#ff5200"
                />
                <rect
                  id="Rectangle_239"
                  data-name="Rectangle 239"
                  width="7.974"
                  height="7.974"
                  transform="translate(250.285 826.268)"
                  fill="#ff5200"
                />
                <rect
                  id="Rectangle_232"
                  data-name="Rectangle 232"
                  width="7.974"
                  height="7.974"
                  transform="translate(234.336 797.561)"
                  fill="#ff5200"
                />
                <rect
                  id="Rectangle_237"
                  data-name="Rectangle 237"
                  width="7.974"
                  height="7.974"
                  transform="translate(234.336 811.664)"
                  fill="#ff5200"
                />
                <rect
                  id="Rectangle_241"
                  data-name="Rectangle 241"
                  width="7.974"
                  height="7.974"
                  transform="translate(234.336 826.268)"
                  fill="#ff5200"
                />
                <rect
                  id="Rectangle_234"
                  data-name="Rectangle 234"
                  width="7.974"
                  height="7.974"
                  transform="translate(266.232 797.561)"
                  fill="#ff5200"
                />
                <rect
                  id="Rectangle_236"
                  data-name="Rectangle 236"
                  width="7.974"
                  height="7.974"
                  transform="translate(266.232 811.664)"
                  fill="#ff5200"
                />
                <rect
                  id="Rectangle_240"
                  data-name="Rectangle 240"
                  width="7.974"
                  height="7.974"
                  transform="translate(266.232 826.268)"
                  fill="#ff5200"
                />
              </g>
            </g>
          </svg>
        </div>
        {!isEmpty(item.data) && (
          <button
            onClick={() => setIndexWeeklyCardOpen(indexWeeklyCardOpen === index ? -1 : index)}
            className="flex items-center justify-center"
          >
            <svg
              transform={getTransformExpandBtn()}
              className="w-8 h-8"
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={3} d="M15 19l-7-7 7-7" />
            </svg>
          </button>
        )}
      </div>
    </div>
  );
};

const CardContentDetails = ({ item }) => {
  return (
    <div className="h-96 grid grid-cols-2 gap-x-8 gap-y-2 mt-16" style={{ overflowY: "scroll" }}>
      {/*<div className="h-64 grid grid-rows-6 grid-flow-col gap-12 mt-16">*/}
      {item &&
        !isEmpty(item.data) &&
        item.data.map((dataInfo, index) => {
          return (
            <div className="flex justify-between">
              <div className="flex">
                <div
                  className={`${
                    expenseReportsDetails[dataInfo.status.id] ? expenseReportsDetails[dataInfo.status.id].style : ""
                  } mr-5 rounded-full h-8 w-8 flex items-center justify-center`}
                >
                  <img
                    className="p-header-menu-logo"
                    src={
                      expenseReportsDetails[dataInfo.status.id] ? expenseReportsDetails[dataInfo.status.id].icon : ""
                    }
                    style={{
                      maxWidth:
                        (expenseReportsDetails[dataInfo.status.id] &&
                          expenseReportsDetails[dataInfo.status.id].icon === "/img/check.png") ||
                        (expenseReportsDetails[dataInfo.status.id] &&
                          expenseReportsDetails[dataInfo.status.id].icon === "/img/timer.png")
                          ? "60%"
                          : "100%"
                    }}
                  />
                </div>
                <div className="mt-2 text-xl font-bold mr-2">{dataInfo.type && dataInfo.type.type} :</div>
                <div className="text-xl mt-2">{Number.parseFloat(dataInfo.price).toFixed(2)} €</div>
              </div>
              <div className="mt-2">{moment(dataInfo.date).format("DD/MM/YYYY")}</div>
            </div>
          );
        })}
    </div>
  );
};

const WeeklyCard = ({ item, index, indexWeeklyCardOpen, setIndexWeeklyCardOpen }) => {
  const getClassNameDisplayedCard = () => (index === indexWeeklyCardOpen ? "row-span-3" : "");

  return (
    <div className={`${getClassNameDisplayedCard()} flex flex-col border border-gray-400 rounded-3xl py-10 px-6 `}>
      <CardContent
        index={index}
        item={item}
        indexWeeklyCardOpen={indexWeeklyCardOpen}
        setIndexWeeklyCardOpen={setIndexWeeklyCardOpen}
      />
      {indexWeeklyCardOpen === index && <CardContentDetails item={item} />}
    </div>
  );
};

const getSummary = (item, initialTab) => {
  const toto = initialTab.map((tabItem, tabIndex) => {
    let counter = 0;

    if (item) console.log("item.data : ", item.data);
    if (tabIndex === 0) counter = item.data.filter(i => i.status.id === 1).length;
    else if (tabIndex === 1) counter = item.data.filter(i => i.status.id === 7).length;
    else if (tabIndex === 2) counter = item.data.filter(i => i.status.id === 5).length;
    else if (tabIndex === 3) counter = item.data.filter(i => i.status.id === 2).length;
    else if (tabIndex === 4) counter = item.data.filter(i => i.status.id === 4).length;
    else if (tabIndex === 5) counter = item.data.filter(i => i.status.id === 3).length;

    return { ...tabItem, count: counter };
  });
  return toto;
};

const ExpenseReportsWeekly = ({ indexWeeklyCardOpen, setIndexWeeklyCardOpen }) => {
  const { expenseReportsWeeklyList, expenseReportsWeeklyData, selectedUserEmail, onChangeWeeklyPage } = useContext(
    ExpenseReportsContext
  );
  const expenseReportsWeeklyListSummaryAdded = !isEmpty(expenseReportsWeeklyList)
    ? expenseReportsWeeklyList.map(item => ({
        ...item,
        summary: isEmpty(item.data) ? [...summaryApprovalItems] : getSummary(item, summaryApprovalItems)
      }))
    : [];

  return (
    <div className="flex py-20 mr-12 flex-col">
      <div className=" w-full grid gap-8 grid-cols-2">
        {!isEmpty(expenseReportsWeeklyList) &&
          expenseReportsWeeklyListSummaryAdded
            .filter(expenseReport => !selectedUserEmail || selectedUserEmail === expenseReport.email)
            .map((item, index) => (
              <WeeklyCard
                index={index}
                item={item}
                indexWeeklyCardOpen={indexWeeklyCardOpen}
                setIndexWeeklyCardOpen={setIndexWeeklyCardOpen}
              />
            ))}
      </div>
      {expenseReportsWeeklyData && (
        <div className="flex justify-end mt-8">
          <Pagination
            defaultCurrent={expenseReportsWeeklyData.page}
            total={expenseReportsWeeklyData.total}
            onChange={onChangeWeeklyPage}
          />
        </div>
      )}
    </div>
  );
};

export default ExpenseReportsWeekly;



// WEBPACK FOOTER //
// src/modules/presence/expenseReports/expenseReportsWeekly/ExpenseReportsWeekly.js